var _style, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#6DA544;}\n\t.st2{fill:#D80027;}\n\t.st3{fill:#FFDA44;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.4,144.7C9.1,178.4,0,216.1,0,256s9.1,77.6,25.4,111.3L256,389.6l230.6-22.3C502.9,333.6,512,295.9,512,256 s-9.1-77.6-25.4-111.3L256,122.4L25.4,144.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.4,367.3C66.8,452.9,154.5,512,256,512s189.2-59.1,230.6-144.7L25.4,367.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.4,144.7h461.2C445.2,59.1,357.5,0,256,0S66.8,59.1,25.4,144.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M211.5,322.8h89v-37.8l-17.8,8.9L256,267.1l-26.7,26.7l-17.8-8.9V322.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.5,278.3l4.1,12.8h13.4l-10.9,7.9l4.1,12.8l-10.9-7.9l-10.9,7.9l4.1-12.8L143,291h13.4L160.5,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M173.4,233.7l4.1,12.8h13.4l-10.9,7.9l4.1,12.8l-10.8-7.9l-10.9,7.9l4.1-12.8l-10.9-7.9h13.4L173.4,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M210.1,200.3l4.1,12.8h13.4l-10.8,7.9l4.1,12.8l-10.8-7.9l-10.8,7.9l4.1-12.8l-10.9-7.9H206L210.1,200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M351.5,278.3l-4.1,12.8h-13.4l10.9,7.9l-4.1,12.8l10.9-7.9l10.8,7.9l-4.1-12.8L369,291h-13.4L351.5,278.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M338.6,233.7l-4.1,12.8h-13.4l10.9,7.9l-4.1,12.8l10.9-7.9l10.9,7.9l-4.1-12.8l10.9-7.9h-13.4L338.6,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.9,200.3l-4.1,12.8h-13.4l10.8,7.9l-4.1,12.8l10.9-7.9l10.8,7.9l-4.1-12.8l10.8-7.9H306L301.9,200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256,183.7l4.1,12.8h13.4l-10.9,7.9l4.1,12.8l-10.9-7.9l-10.9,7.9l4.1-12.8l-10.9-7.9h13.4L256,183.7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/tj.6de0fa81a6671cdb50a56ee008a3eb15.svg";
export { ForwardRef as ReactComponent };